import { render } from "./VabMenuItem.vue?vue&type=template&id=6ba69601&scoped=true"
import script from "./VabMenuItem.vue?vue&type=script&lang=js"
export * from "./VabMenuItem.vue?vue&type=script&lang=js"

import "./VabMenuItem.vue?vue&type=style&index=0&id=6ba69601&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba69601"],['__file',"src/vab/components/VabMenu/components/VabMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ba69601"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ba69601', __exports__)) {
    api.reload('6ba69601', __exports__)
  }
  
  module.hot.accept("./VabMenuItem.vue?vue&type=template&id=6ba69601&scoped=true", () => {
    api.rerender('6ba69601', render)
  })

}


export default __exports__